import type { ReactNode, CSSProperties } from "react";
import type { CmsBackground } from "@/lib/api/cms-windows";
import { backgroundToStyle } from "./bgStyle";

/**
 * CEmpty — passthrough kontener dla katalogów (`c_*`).
 *
 * **Rola:** semantyczny `<article>` BEZ wizualnej oprawy (bez tła/ramki/h1).
 * Treść katalogu sama zarządza swoją typografią (np. landing page z własnym
 * hero `<h1>` w środku). Wcześniej rolę pełnił `KCatalogEmpty` w
 * `CatalogContainer.tsx` (warstwa drop'nięta).
 *
 * **2 opcje konfiguracji** (props):
 *   - **treść** (`children`) — content variant'a katalogu
 *   - **tło** (`background`) — `CmsBackground` aplikowany jako inline style;
 *     gdy null/empty, brak inline style (czyste passthrough). UWAGA: bez tła
 *     i ramki tło może wyglądać "naked" jeśli admin chce edge-to-edge hero —
 *     wtedy variant powinien renderować własny full-width section wewnątrz.
 *
 * Brak `title` props — `CEmpty` z założenia NIE renderuje page title.
 * Jeśli variant chce h1, włącza go we własnym markup.
 */
export function CEmpty({ background, children }: CEmptyProps) {
  const bgStyle: CSSProperties | undefined = (() => {
    const s = backgroundToStyle(background);
    return Object.keys(s).length > 0 ? s : undefined;
  })();

  return <article style={bgStyle}>{children}</article>;
}

export type CEmptyProps = {
  background?: CmsBackground | null;
  children: ReactNode;
};
